<template>
  <div>
    <legend>Пользователи панели</legend>
    <dx-data-grid
      :show-borders="true"
      :data-source="dataSource"
      :remote-operations="true"
      ref="dataGridComponent"
    >
      <dx-editing
        :allow-updating="true"
        :allow-deleting="true"
        :allow-adding="true"
        mode="row"
      />
      <dx-column
        data-field="Login"
        caption="Логин"
      />
      <dx-column
        data-field="Email"
        caption="Email"
      />
      <dx-column
        data-field="Fname"
        caption="Имя"
      />
      <dx-column
        data-field="Lname"
        caption="Фамилия"
      />
      <dx-column
        data-field="Mname"
        caption="Отчество"
      />

      <dx-column
        data-field="Password"
        caption="Пароль"
      />
      <dx-column
        :width="200"
        :allow-sorting="false"
        :cell-template="cellTemplate"
        data-field="UserRole"
        caption="Роль"
        edit-cell-template="tagBoxEditor"
      >
        <dx-lookup
          :data-source="roleDataSource"
          value-expr="Id"
          display-expr="Name"
        />
      </dx-column>
      <dx-column
        :width="200"
        data-field="TourId"
        caption="Объезд К"
      >
        <dx-lookup
          :data-source="partnerTourDataSource"
          value-expr="Id"
          display-expr="Name"
        />
      </dx-column>
      <div
        slot="tagBoxEditor"
        slot-scope="{ data: cellInfo }"
      >
        <dx-tag-box
          :value="cellInfo.value"
          :on-value-changed="(value) => onValueChanged(value, cellInfo)"
          :data-source="roleDataSource"
          :data-grid-component="cellInfo.component"
          :show-selection-controls="true"
          :max-displayed-tags="3"
          :show-multi-tag-only="false"
          :search-enabled="true"
          value-expr="Id"
          display-expr="Name"
          apply-value-mode="useButtons"
        />
      </div>
    </dx-data-grid>
  </div>
</template>
<script>
import { createStore } from 'devextreme-aspnet-data-nojquery';
import {
  DxColumn, DxDataGrid, DxEditing, DxLookup,
} from 'devextreme-vue/data-grid';
import DxTagBox from 'devextreme-vue/tag-box';
import token from '@/admin/services/token';


const url = `${process.env.VUE_APP_API_HOST}admin/panel-user`;
const roleUrl = `${process.env.VUE_APP_API_HOST}admin/role`;
const partnerTourUrl = `${process.env.VUE_APP_API_HOST}admin/tour`;

const dataSource = createStore({
  key: 'Id',
  loadUrl: `${url}`,
  insertUrl: `${url}/insert`,
  updateUrl: `${url}/update`,
  deleteUrl: `${url}/delete`,
  onBeforeSend(operation, ajaxOptions) {
    ajaxOptions.headers = {
      Authorization: `Bearer ${token}`,
    };
  },
});

const roleDataSource = createStore({
  key: 'Id',
  loadUrl: `${roleUrl}`,
  onBeforeSend(operation, ajaxOptions) {
    ajaxOptions.headers = {
      Authorization: `Bearer ${token}`,
    };
  },
});


const partnerTourDataSource = createStore({
  key: 'Id',
  loadUrl: `${partnerTourUrl}`,
  onBeforeSend(operation, ajaxOptions) {
    ajaxOptions.headers = {
      Authorization: `Bearer ${token}`,
    };
  },
});
export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxLookup,
    DxTagBox,

  },
  data() {
    return {
      dataSource,
      roleDataSource,
      partnerTourDataSource,
    };
  },
  methods: {
    cellTemplate(container, options) {
      const noBreakSpace = '\u00A0';
      const text = (options.value || []).map(element => options.column.lookup.calculateCellValue(element)).join(', ');
      container.textContent = text || noBreakSpace;
      container.title = text;
    },
    cellTemplate2(container, options) {
      console.log(container, options);
      // const noBreakSpace = '\u00A0';
      // const text = (options.value || []).map(element => options.column.lookup.calculateCellValue(element)).join(', ');
      container.textContent = text || noBreakSpace;
      container.title = 1;
    },
    onValueChanged(value, cellInfo) {
      cellInfo.setValue(value.value);
      cellInfo.component.updateDimensions();
    },
    // onSelectionChanged(e) {
    //   console.log(e.component);
    //   // e.component.updateDimensions();
    // },
  },
};
</script>
